import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import TrashIcon from '../../../../../../themes/svg/trashIcon';
import CloseIcon from '../../../../../../themes/svg/closeIcon';

class DeleteItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
  }

  componentWillMount() {
    Modal.setAppElement('#estimateBuilderRoot');
  }

  onCloseClick = (e) => {
    this.closeModal();
    e.preventDefault();
  }

  openModal = (e) => {
    this.setState({ modalIsOpen: true });
    e.preventDefault();
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  }

  deleteItem = () => {
    const { deleteItem, designId, itemId } = this.props;
    deleteItem(designId, itemId);
  }

  render() {
    return (
      <div className="actionBarItem">
        <a href="/" onClick={this.openModal}>
          <div className="actionBarIcon"><TrashIcon /></div>
          <span className="label link">Delete</span>
        </a>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          className="estimatebuilder-modal"
          overlayClassName="estimatebuilder-modal-overlay"
          style={{
            content: {
              width: 450,
            },
          }}
        >
          <div className="confirmDeleteModal">
            <h2>Delete Window</h2>

            <div className="modal-close" onClick={this.onCloseClick} tabIndex="-1" role="button"><CloseIcon /></div>
            <div className="modal-body">
              <p>
                Are you sure you want to delete this window and all of its associated information?
              </p>
              <button className="btn btn-primary" onClick={this.deleteItem}>Delete Window</button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

DeleteItem.propTypes = {
  designId: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  deleteItem: PropTypes.func.isRequired,
};


export default DeleteItem;
